import { render, staticRenderFns } from "./TouchComplete.vue?vue&type=template&id=456ddcd6&scoped=true&"
import script from "./TouchComplete.vue?vue&type=script&lang=js&"
export * from "./TouchComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456ddcd6",
  null
  
)

export default component.exports